import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { routerMiddleware, connectRouter } from 'connected-react-router';
import { Auth } from '@justgiving/auth';
import thunk from 'redux-thunk';
import { History } from 'history';
import reducers from './reducers';

const configureStore = (
  { initialState = {} },
  history: History,
  auth: Auth,
) => {
  const router = routerMiddleware(history);
  const middleware = [thunk.withExtraArgument(auth), router];

  const reducer = combineReducers({
    ...reducers,
  });
  const store = createStore(
    connectRouter(history)(reducer),
    initialState,
    composeWithDevTools(applyMiddleware(...middleware)),
  );

  return store;
};

export default configureStore;
